<template>
    <div v-if="visible" :class="['alert', 'alert-dismissible', 'fade', 'show', alertClass, 'floating-alert']" role="alert">
        {{ message }}
    </div>
</template>

<script>
import eventBus from '@/utils/eventBus';

export default {
    data() {
        return {
            visible: false,
            message: '',
            type: '',
            sessionTimeout: null
        };
    },
    computed: {
        alertClass() {
            return `alert-${this.type}`
        }
    },
    created() {
        eventBus.on('show-alert', this.displayAlert);
    },
    beforeUnmount() {
        eventBus.off('show-alert', this.displayAlert);
    },
    methods: {
        displayAlert(payload) {
            this.message = payload.message;
            this.visible = true;
            this.type = payload.type;
            
            setTimeout(() => {
                this.visible = false;
            }, 5000);
        }
    }
}
</script>

<style scoped>
.floating-alert {
    position: fixed;
    top: 65px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 1050;
    min-width: 200px;
}
</style>